import { Button, Select, Table } from "antd";
import React, { useState } from "react";
import {
  useConnectProvider,
  useDisconnectProvider,
  useGetUnconnectedProviders,
} from "../../../queries/provider-resource";
import { ProviderResource } from "../ResourceTable.types";
import { groupSelectOptionsOnProperty } from "../groupSelectOptionsOnProperty.function";
import { useTranslation } from "react-i18next";

interface ConnectedProviderResourceTableProps {
  dataSource: ProviderResource[];
  resourceId: string;
}

const ConnectedProviderResourceTable = ({
  dataSource,
  resourceId,
}: ConnectedProviderResourceTableProps) => {
  const { t } = useTranslation();
  const { data: providerResourcesData } = useGetUnconnectedProviders();
  const { mutate: connectResource } = useConnectProvider();
  const { mutate: disconnectResource } = useDisconnectProvider();

  const providerResourcesSelectOptions = groupSelectOptionsOnProperty(
    providerResourcesData,
  );

  const [optionSelectValue] = useState<string | null>(null);

  const columns = [
    {
      title: t("pages.resources.provider-resource-table.name"),
      dataIndex: "name",
      key: "name",
      width: "25%",
      render: (text: string) => (
        <span style={{ wordWrap: "break-word" }}>{text}</span>
      ),
    },
    {
      title: t("pages.resources.provider-resource-table.providers-id"),
      dataIndex: "externalId",
      key: "externalId",
      width: "25%",
      render: (text: string) => (
        <span style={{ wordWrap: "break-word" }}>{text}</span>
      ),
    },
    {
      title: t("pages.resources.provider-resource-table.service-account"),
      dataIndex: "accountAddress",
      key: "accountAddress",
      width: "25%",
      render: (text: string) => (
        <span style={{ wordWrap: "break-word" }}>{text}</span>
      ),
    },
    {
      title: t("action"),
      key: "action",
      width: "10%",
      render: (record: { id: string }) => (
        <Button
          danger
          type="link"
          onClick={() => disconnectResource(record.id)}
        >
          {t("pages.resources.provider-resource-table.disconnect")}
        </Button>
      ),
    },
  ];

  const onDropdownSelect = (value: string, resourceId: string) => {
    connectResource({ providerResourceId: value, resourceId: resourceId });
  };

  return (
    <>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey={(record) => record.id}
        pagination={false}
        tableLayout={"fixed"}
      />
      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "right",
        }}
      >
        <Select
          placeholder={t(
            "pages.resources.provider-resource-table.connect-resource",
          )}
          options={providerResourcesSelectOptions}
          style={{ width: "16rem" }}
          value={optionSelectValue}
          onSelect={(value) => onDropdownSelect(value, resourceId)}
        />
      </div>
    </>
  );
};

export default ConnectedProviderResourceTable;
